import { ClassProvider } from "@angular/core";
import { Types } from "../../../domain/types.domain";
import { GetInviteService } from "../../../domain/invite/services/get-invite.service";

export class GetInviteServiceInstruction implements ClassProvider {
  provide = Types.GetInviteService;
  useClass = GetInviteService;
  deps = [Types.Settings]
}